module.exports = __webpack_public_path__ + "img/AnnAmeling.96ed9355.png";